var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.franchiseId)?_c('create-doctor',{attrs:{"fetchClinicsBy":"superAdmin","franchiseId":_vm.franchiseId}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }